var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "13px",
    viewBox: "0 0 9 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-3",
    transform: "translate(-319, -442)",
    fill: "#000000",
    fillRule: "nonzero",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(57, 367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-down",
    transform: "translate(266.5, 81.1429) rotate(-90) translate(-266.5, -81.1429)translate(261, 78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.665243826,6.34629466e-15 C0.495197146,6.34629466e-15 0.322647593,0.0674357233 0.193662898,0.198936542 C-0.0645542993,0.462186607 -0.0645542993,0.897483981 0.193662898,1.16073405 L5.0255295,6.08677773 C5.15024154,6.21392053 5.32618401,6.28571428 5.49711042,6.28571428 C5.66643019,6.28571428 5.83518413,6.2228829 5.96869135,6.08677773 L10.7939497,1.16705003 C11.0642682,0.90767376 11.0677376,0.462102394 10.8095185,0.198852329 C10.5512995,-0.0643977367 10.1243261,-0.0643977367 9.86610884,0.198852329 L5.50574447,4.65304624 L1.13666157,0.198806285 C1.05050933,0.110974858 0.893370075,0.0447060957 0.665243826,6.34629466e-15 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowSmall);
export default __webpack_public_path__ + "static/media/right-arrow--small.43d8ef328bcfc176eb29e0928bd36398.svg";
export { ForwardRef as ReactComponent };